import {locationHistorySelector, TransportAssocEntity, useGetTicketLocationHistoryQuery} from "@ots-frontend/ots-data";
import {LocationHistoryMap} from "../../map/LocationHistoryMap/LocationHistoryMap";
import {useMemo} from "react";
import {getShiftLocationHistory} from "../../map/LocationHistoryMap/util";
import {LocationHistoryMapFilter, ShiftLocationHistory} from "../../../model/location-history";

export type TicketMapProps = {
  ticket: TransportAssocEntity
}

export const TicketMap = (props: TicketMapProps) => {
  const {ticket} = props;

  const selectLocationHistory = useMemo(() => {
    return locationHistorySelector()
  }, []);

  const {locationHistory} = useGetTicketLocationHistoryQuery({
    id: ticket.id,
    database: ticket.database,
  }, {
    selectFromResult: (result) => ({
      locationHistory: selectLocationHistory(result),
      isFetching: result.isFetching
    })
  });

  const shiftLocationHistory: ShiftLocationHistory | undefined = useMemo(() => {
    return locationHistory && locationHistory.shifts.length > 0 ? getShiftLocationHistory(locationHistory, locationHistory.shifts[0].id) : undefined
  }, [locationHistory])

  const filter: LocationHistoryMapFilter = useMemo(() => {
    return {
      showSites: false,
      showTransportRoutes: true,
      showGeofenceEvents: true,
      showDriverLocations: true,
      showDriverLocationRoute: false,
      selectedTransportIds: [ticket.pickupTransportId!, ticket.deliveryTransportId!]
    }
  }, [ticket])

  return (
    <LocationHistoryMap
      data={shiftLocationHistory}
      filter={filter}
    />
  );
};

